module.exports = __webpack_public_path__ + "static/fdm_printer-6181cf886b80a2f7ca886da5366dc298.jpg";